'use client'

import { MAX_IMPRESSIONS_COUNT } from 'analytics/constants/impressions'
import { useAnalyticsImpressions } from 'analytics/hooks/useAnalyticsImpressions/useAnalyticsImpressions'
import { useImpressionCount } from 'analytics/hooks/useImpressionCount/useImpressionCount'
import { useBeforeUnload } from 'hooks/useBeforeUnload/useBeforeUnload'
import { useVisibilityChange } from 'hooks/useVisibilityChange/useVisibilityChange'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'

export const useAnalyticsImpressionsEffects = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const initialRender = useRef(true)

	const currentUrl =
		pathname + (searchParams.size > 0 ? `?${searchParams.toString()}` : '')

	const impressionCount = useImpressionCount()
	const { flushImpressions } = useAnalyticsImpressions()

	useBeforeUnload(flushImpressions)

	useVisibilityChange(flushImpressions)

	// This effect is used to flush impressions when the impression count reaches the maximum limit
	useEffect(() => {
		if (impressionCount >= MAX_IMPRESSIONS_COUNT) {
			flushImpressions()
		}
	}, [impressionCount, flushImpressions])

	// This effect is used to flush impressions when the URL changes
	useEffect(() => {
		if (initialRender.current) {
			initialRender.current = false
			return
		}

		// If the URL changes, flush impressions
		if (currentUrl) {
			flushImpressions()
		}
	}, [currentUrl, flushImpressions])
}
